// optional-unified.js
// Gestisce sia gli optional product-based (data-lb-optional)
// sia quelli variant-based (data-vr-optional-container / window.VR_VARIANTS)
var titolo_bf_optional
(() => {
  if (window.__optionalUnifiedInit) return;
  window.__optionalUnifiedInit = true;

  // ─────────────────────────────────────────────
  // VR-OPTIONAL: render dinamico per variante
  // ─────────────────────────────────────────────

  const variants = window.VR_VARIANTS || [];

  function getVrContainer() {
    return document.querySelector('[data-vr-optional-container]');
  }

  function renderVrOptionals(variantId) {
    const container = getVrContainer();
    if (!container) return;

    const variant = variants.find(v => v.id == variantId);

    if (!variant || !variant.optional || variant.optional.length === 0) {
      container.innerHTML = '';
      return;
    }

    const validOptionals = variant.optional.filter(p =>
      p && p.variants && p.variants.length > 0 && p.variants[0].available !== false
    );

    if (validOptionals.length === 0) {
      container.innerHTML = '';
      return;
    }

    const useAccordion = validOptionals.length > 5;

    const itemsHtml = validOptionals.map(p => {
      const v = p.variants[0];
      const qtyMode = v.qty_mode || 'one';

      return `
        <label class="lb-optional__item">
          <input
            type="checkbox"
            class="lb-optional__checkbox"
            value="${v.id}"
            data-qty-mode="${qtyMode}"
          >
          <span class="lb-optional__name" style="font-size:large;">${p.title}</span>
          ${qtyMode === 'custom'
            ? `<input type="number" class="lb-optional__qty" min="1" step="1" value="1">`
            : ''}
          <span class="lb-optional__price">${v.price_html || ''}</span>
        </label>
      `;
    }).join('');

    if (useAccordion) {
      container.innerHTML = `
        <details class="lb-accordion" data-lb-accordion>
          <summary class="lb-accordion__summary">
            <span class="lb-accordion__title">Optional</span>
            <span class="lb-accordion__icon" aria-hidden="true"></span>
          </summary>
          <div class="lb-accordion__content">
            <div class="lb-optional" data-lb-optional-inner>
              ${itemsHtml}
            </div>
          </div>
        </details>
      `;
    } else {
      container.innerHTML = `
        <h3 class="lb-optional__title">Optional</h3>
        <div class="lb-optional" data-lb-optional-inner>
          ${itemsHtml}
        </div>
      `;
    }
  }

  // Ascolta cambio variante
  document.addEventListener('change', (e) => {
    if (e.target.name === 'id' || e.target.matches('[name="id"]')) {
      renderVrOptionals(e.target.value);
    }
  });

  // Init VR su DOMContentLoaded
  const initVr = () => {
    const input = document.querySelector("form[action*='/cart/add'] [name='id']");
    if (input) renderVrOptionals(input.value);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVr);
  } else {
    initVr();
  }

  // ─────────────────────────────────────────────
  // SUBMIT HANDLER UNIFICATO
  // Cerca optional sia nel wrap lb che nel container vr
  // ─────────────────────────────────────────────

  function findCheckboxes(form) {
    // 1. Cerca wrap product-based (data-lb-optional diretto nella sezione)
    const lbWrap = form
      .closest('section, .shopify-section, .product, main, body')
      ?.querySelector('[data-lb-optional]');

    // 2. Cerca container variant-based
    const vrContainer = document.querySelector('[data-vr-optional-container]');
    const vrInner = vrContainer?.querySelector('[data-lb-optional-inner]');

    // Raccoglie checkbox da entrambe le fonti (evita duplicati se stessa lista)
    const sources = [];
    if (lbWrap) sources.push(lbWrap);
    if (vrInner && vrInner !== lbWrap) sources.push(vrInner);

    return sources.flatMap(el =>
      Array.from(el.querySelectorAll('.lb-optional__checkbox'))
    );
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    const checkboxes = findCheckboxes(form);

    // Nessun optional presente → lascia gestire al tema
    if (checkboxes.length === 0) return;

    // Lock anti-doppio invio
    if (form.dataset.vrProcessed === '1') {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    form.dataset.vrProcessed = '1';

    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    const fd = new FormData(form);
    const mainVariantId = Number(fd.get('id'));

    if (!mainVariantId) {
      form.dataset.vrProcessed = '0';
      if (submitBtn) submitBtn.disabled = false;
      return;
    }

    const qty = Math.max(1, parseInt(fd.get('quantity') || '1', 10));

    const selectedAddons = checkboxes
      .filter(cb => cb.checked)
      .map(cb => {
        const row = cb.closest('.lb-optional__item');
        const mode = cb.dataset.qtyMode || 'one';
        let addonQty = 1;

        if (mode === 'custom') {
          const qtyInput = row?.querySelector('.lb-optional__qty');
          addonQty = Math.max(1, parseInt(qtyInput?.value || '1', 10));
        }

        return {
          id: Number(cb.value),
          quantity: addonQty,
          parent_id: mainVariantId
        };
      })
      .filter(x => x.id);

    const items = [
      { id: mainVariantId, quantity: qty },
      ...selectedAddons
    ];

    try {
      let root = window.Shopify?.routes?.root || '/';
      if (!root.endsWith('/')) root += '/';

      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items })
      });

      if (!res.ok) throw new Error(await res.text());

      // Reset checkbox
      checkboxes.forEach(cb => (cb.checked = false));

      // Notifica il tema per aprire il side cart
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: true }
      }));

    } catch (err) {
      console.error('Optional Cart Error:', err);
    } finally {
      form.dataset.vrProcessed = '0';
      if (submitBtn) submitBtn.disabled = false;
    }

  }, true); // capture: intercetta prima del tema

  // ─────────────────────────────────────────────
  // FIX SIDE CART: chiusura drawer
  // ─────────────────────────────────────────────

  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('#CartDrawer .drawer__close-btn.static');
    if (!closeBtn) return;

    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('inert', '');
      drawer.removeAttribute('open');
      drawer.removeAttribute('active');
      document.body.classList.remove('modal-show');
      drawer.querySelector('.fixed-overlay')?.setAttribute('aria-expanded', 'false');
    }
  });

})();
